module.exports = __webpack_public_path__ + "static/media/img-destaque-internas.0d00f029.jpg";